import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "close-x",
  "use": "close-x-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol viewBox=\"0 0 12 10\" id=\"close-x\">\n    <g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#BFC5D2\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n        <path d=\"M11 0L1 10M11 10L1 0\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svgs/close-x.svg
// module id = 167
// module chunks = 0